import { render, staticRenderFns } from "./corporateImage.vue?vue&type=template&id=42afe4e2&scoped=true"
import script from "./corporateImage.vue?vue&type=script&lang=js"
export * from "./corporateImage.vue?vue&type=script&lang=js"
import style0 from "./corporateImage.vue?vue&type=style&index=0&id=42afe4e2&prod&lang=less&scoped=true"
import style1 from "./corporateImage.vue?vue&type=style&index=1&id=42afe4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afe4e2",
  null
  
)

export default component.exports